export const EVENT_REGISTRY = {
  // Client boot / navigation
  'client.boot.ok': 'App booted and reached first render',
  'client.route.change': 'Client-side navigation',
  'client.route.error': 'Navigation into a route that threw',

  // UI error boundary
  'ui.boundary.root': 'Root App boundary caught',
  'ui.boundary.route': 'Per-route boundary caught',
  'ui.unhandled.rejection': 'window.onunhandledrejection',
  'ui.window.error': 'window.onerror',

  // Callables (client-side view)
  'callable.request': 'Callable dispatched (DEBUG in debug mode only)',
  'callable.success': 'Callable succeeded (INFO in debug mode only)',
  'callable.retry': 'Callable retry attempt (WARN)',
  'callable.timeout': 'Callable timed out client-side (ERROR)',
  'callable.error': 'Callable rejected (WARN or ERROR by code class)',
  'callable.aborted': 'Callable aborted client-side (INFO)',

  // Callables (server-side view — emitted by functions/src/lib/callable.ts)
  'server.callable.ok': 'Handler completed successfully (INFO)',
  'server.callable.error': 'Handler threw (ERROR)',
  'server.callable.dedupe.hit': 'Idempotency cache hit (INFO)',

  // Debug session lifecycle
  'debug.session.started': 'User turned debug mode on',
  'debug.session.stopped': 'User turned debug mode off',
  'debug.session.bundle_sent': 'Debug session attached to a support ticket',
} as const

export type KnownEvent = keyof typeof EVENT_REGISTRY

export const isKnownEvent = (event: string): event is KnownEvent =>
  Object.prototype.hasOwnProperty.call(EVENT_REGISTRY, event)
